import { Instance, types } from 'mobx-state-tree';

import StudentProgramsGrade from './Grade';

const StudentProgramLesson = types.model('StudentProgramLesson', {
	assessment_type_id: types.maybeNull(types.number),
	lesson_id: types.identifierNumber,
	lesson_name: types.string,
	schedule_lesson_name: types.maybeNull(types.string),
	schedule_lesson_id: types.number,
	lesson_image: types.maybeNull(types.string),
	lesson_sort_id: types.number,
	start: types.optional(types.string, ''),
	status: types.maybeNull(types.number), // @TODO: 1: checking, 0 : in progress 2:done
	comment: types.maybeNull(types.string),
	comment_created_at: types.maybeNull(types.string),
	teacher_first_name: types.optional(types.maybeNull(types.string), ''),
	teacher_last_name: types.optional(types.maybeNull(types.string), ''),
	grade: types.optional(types.array(StudentProgramsGrade), []),
	gradebook_final_grade: types.maybeNull(types.string),
	gradebook_final_comment: types.maybeNull(types.string),
	gradebook_comment_created_at: types.maybeNull(types.string),
	is_lock: false,
	deadline: types.maybeNull(types.string),
});

export default StudentProgramLesson;

export interface IStudentProgramLessonModel extends Instance<typeof StudentProgramLesson> {}
